import styled from "styled-components";
import {
	DESKTOP_SM_BP,
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
	TABLET_BP,
	MOBILE_L_BP,
	COLOR_TEXT_PRIMARY_B2C,
} from "@website-builder/utilities-index";

export const HeroWrapper = styled.div`
	display: flex;
	align-items: center;
	background-image: linear-gradient(to top, #efeff6 5%, #f6fdfb 96%);
	color: ${(props) => props.fontColor};
	padding-top: 120px;
	padding-bottom: 70px;
	.joinusWrapper {
		max-width: 600px;
		margin-left: 70px;
		h2.header {
			font-weight: ${FONT_WT_MEDIUM};
			font-size: 36px;
			line-height: 1.4;
			margin: 0 0 30px 0;
			color: ${COLOR_TEXT_PRIMARY_B2C};
		}
		p.description {
			margin: 0 0 40px 0;
			font-weight: ${FONT_WT_LIGHT};
			font-size: 18px;
			line-height: 1.44;
			color: ${COLOR_TEXT_PRIMARY_B2C};
		}
		button.join-button {
			padding-inline: 48px;
		}
	}
	.imageWrapper {
		margin-right: 70px;
		width: 65%;
		h3.header {
			margin: 0 0 25px 0;
			font-weight: ${FONT_WT_MEDIUM};
			font-size: 20px;
			line-height: 20px;
		}
		.heroImage {
			float: right;
		}
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		padding: 35px 30px;
		padding-top: 70px;
		.imageWrapper {
			display: none;
		}
		a {
			text-decoration: none;
		}
		.joinusWrapper {
			margin: 0 auto;
			h2.header {
				text-align: center;
				font-size: 26px;
				line-height: 36px;
				margin: 35px 100px 33px 100px;
			}
			p.description {
				font-size: 16px;
				line-height: 27px;
				text-align: center;
				margin-left: 70px;
				margin-right: 70px;
			}
			.join-button {
				display: flex;
				margin: auto;
				align-items: center;
			}
		}
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 35px 20px;
		padding-top: 70px;
		.joinusWrapper {
			h2.header {
				margin: 0px 0px 30px 0px;
				font-size: 28px;
				line-height: 1.21;
			}
			p.description {
				font-size: 18px;
				line-height: 1.44;
				text-align: center;
				margin-left: 25px;
				margin-right: 25px;
			}
		}
		.join-button {
			display: flex;
			margin: auto;
			align-items: center;
		}
	}
	@media only screen and (max-width: ${TABLET_BP}px) {
		${(props) => (props.showInTabletAndMobile ? "" : "display: none")}
		.join-button {
			display: flex;
			margin: auto;
			align-items: center;
		}
	}
`;
